import { styled, css } from '../../theme';
import { Icon } from '../Icon';
import { Paragraph } from '../Paragraph';

export const StoreWarningMessage = styled(Paragraph).attrs((props) => ({
	...props,
	style: 'bold',
}))<{ visible: boolean }>`
	opacity: 0;
	width: 100%;
	display: block;
	text-align: center;
	box-sizing: border-box;
	background-color: ${({ theme }) => theme.color.red.base};
	color: ${({ theme }) => theme.color.white.base};
	padding: ${({ theme }) => theme.space.sm}px ${({ theme }) => theme.space.md}px;
	font-size: ${({ theme }) => theme.fontSize.sm}px;
	margin: 0;
	transition: opacity 0.2s ease-in-out;

	@media ${({ theme }) => theme.device.laptop} {
		padding: ${({ theme }) => theme.space.sm}px ${({ theme }) => theme.space.lg}px;
	}

	${({ visible }) =>
		visible &&
		css`
			opacity: 1;
		`}
`;
export const StoreWarningMessageIcon = styled(Icon).attrs((props) => ({
	...props,
	name: 'IconInfoWhiteSm',
}))`
	display: inline-block;
	margin-bottom: -2px;
	margin-right: ${({ theme }) => theme.space.sm}px;
`;
